<template>
  <v-dialog v-model="externalAccountHelperData.modalFTPVisible" width="500">
    <v-card>
      <v-card-title class="d-flex">
        Link External Accounts
        <v-spacer />
        <v-icon @click="closeModal" size="x-small" icon="mdi-window-close"></v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <form v-on:submit.prevent>
          <v-alert id="showFtpErr" v-show="externalAccountHelperData.showFtpErr" type="error" density="compact"></v-alert>
          <div class="mt-2">
            <label class="font-weight-bold">FTP Server</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.ftpServerParse" placeholder="ftp.yourdomain.com / IP Address" />
          </div>
          <div>
            <label class="font-weight-bold">FTP Username</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.ftpUser" />
          </div>
          <div>
            <label class="font-weight-bold">FTP Password</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.ftpPassword" />
          </div>
          <div>
            <label class="font-weight-bold">FTP Port</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.ftpPort" />
          </div>
          <div class="d-flex">
            <div v-if="externalAccountHelperData.externalAccountId">
              <v-btn :disabled="externalAccountHelperData.isProcessing" @click="externalAccountHelperData.doEditFtp()" color="black" variant="flat">Save</v-btn>
            </div>
            <div v-if="!externalAccountHelperData.externalAccountId" >
              <v-btn variant="flat" @click="externalAccountHelperData.doCreateFtp()" color="black" class="text-none mr-3">
                {{externalAccountHelperData.ftpType === 'sftp' ? 'add SFTP Account' : 'add FTP account'}}
              </v-btn>
            </div>
            <v-btn variant="flat" color="#DAD7D7" @click="externalAccountHelperData.modalFTPVisible = false" class="text-none ml-2">Cancel</v-btn>
          </div>
        </form>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog v-model="externalAccountHelperData.modalSFTPVisible" width="500">
    <v-card>
      <v-card-title class="d-flex">
        Link External Accounts
        <v-spacer />
        <v-icon @click="closeModal" size="x-small" icon="mdi-window-close"></v-icon>
      </v-card-title>
      <v-divider class="my-1" />
      <v-card-text>
        <form v-on:submit.prevent>
          <v-alert id="showSftpErr" v-show="externalAccountHelperData.showSftpErr" type="error" density="compact"></v-alert>
          <div class="mt-2">
            <label class="font-weight-bold">Authorization Method</label>
            <v-select  class="mt-1" v-model="externalAccountHelperData.sftpAuthType" variant="outlined" density="compact" :items="sftpAuthType" item-value="id" item-title="name" />
          </div>
          <div>
            <label class="font-weight-bold">Server</label>
            <v-text-field class="mt-1" variant="outlined" density="compact"  v-model="externalAccountHelperData.ftpServerParse" placeholder="sftp.yourdomain.com / IP Address" />
          </div>
          <div>
            <label class="font-weight-bold">Username</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.ftpUser" />
          </div>
          <div v-if="externalAccountHelperData.sftpAuthType === 'key'">
            <label class="font-weight-bold">RSA Key</label>
            <v-textarea class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.sftpKey" />
          </div>
          <div v-if="externalAccountHelperData.sftpAuthType === 'key'">
            <label class="font-weight-bold">Key Phrase</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.sftpKeyPhrase" />
          </div>
          <div  v-if="externalAccountHelperData.sftpAuthType === 'password'">
            <label class="font-weight-bold">Password</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.sftpPassword" />
          </div>
          <div>
            <label class="font-weight-bold">Port</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.ftpPort" />
          </div>
          <div class="d-flex">
            <div v-if="externalAccountHelperData.externalAccountId">
            <v-btn :disabled="externalAccountHelperData.isProcessing" @click="externalAccountHelperData.doEditSftp()" color="black" variant="flat">Save</v-btn>
            </div>
            <div v-if="!externalAccountHelperData.externalAccountId">
              <v-btn variant="flat" @click="externalAccountHelperData.doCreateSftp()" color="black" class="text-none mr-3">
                Add SFTP account
              </v-btn>
            </div>
            <v-btn variant="flat" color="#DAD7D7" @click="externalAccountHelperData.modalSFTPVisible = false" class="text-none ml-2">Cancel</v-btn>
          </div>
        </form>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog v-model="externalAccountHelperData.modalS3Visible" width="500">
    <v-card>
      <v-card-title class="d-flex">
        Link External Accounts
        <v-spacer />
        <v-icon @click="closeModal" size="x-small" icon="mdi-window-close"></v-icon>
      </v-card-title>
      <v-divider class="my-1" />
      <v-card-text>
        <form v-on:submit.prevent>
          <v-alert id="showS3Err" v-show="externalAccountHelperData.showS3Err" type="error" density="compact"></v-alert>
          <div class="mt-2">
            <label class="font-weight-bold">AWS S3 Authorization Method</label>
            <v-select class="mt-1" v-model="externalAccountHelperData.s3AuthType" variant="outlined" density="compact" :items="s3AuthMethod" item-value="id" item-title="name" />
          </div>
          <div v-if="externalAccountHelperData.s3AuthType == 'pool_id'">
            <label class="font-weight-bold">Identity Pool ID</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.identityPoolId" />
          </div>
          <div v-if="externalAccountHelperData.s3AuthType == 'access_key'">
            <label class="font-weight-bold align-center">Access Key ID</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.accessKey" />
          </div>
          <div v-if="externalAccountHelperData.s3AuthType === 'access_key'">
            <label class="font-weight-bold">Secret Access Key</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.secretToken" />
          </div>
          <div>
            <label class="font-weight-bold">Region</label>
            <v-autocomplete class="mt-1" variant="outlined" v-model="externalAccountHelperData.region"
                            density="compact" :items="regionList" item-value="id" item-title="name"
                            label="Please Select" clearable />
          </div>
          <div>
            <label class="font-weight-bold">Bucket name</label>
            <v-text-field class="mt-1" variant="outlined" density="compact" v-model="externalAccountHelperData.bucketname" />
          </div>
          <div class="d-flex">
            <div v-if="externalAccountHelperData.externalAccountId">
              <v-btn :disabled="externalAccountHelperData.isProcessing" @click="externalAccountHelperData.doEditS3()" color="black" variant="flat">Save</v-btn>
            </div>
            <div class="justify-left" v-if="!externalAccountHelperData.externalAccountId">
              <v-btn variant="flat" @click="externalAccountHelperData.doCreateS3()" color="black" class="text-none mr-3" prepend-icon="mdi-aws">
                Add S3 account
              </v-btn>
            </div>
            <v-btn variant="flat" color="#DAD7D7"  @click="externalAccountHelperData.modalS3Visible = false" class="text-none ml-2">Cancel</v-btn>
          </div>
        </form>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog v-model="externalAccountHelperData.modalVisible" max-width="800">
    <v-card>
      <v-card-title class="d-flex flex-wrap">
        Add File Storage
        <v-spacer />
        <v-icon @click="closeModal" size="x-small" icon="mdi-window-close"></v-icon>
      </v-card-title>
      <v-divider class="my-2" />
      <v-card-text>
        <v-row class="d-flex justify-center">
          <v-col lg="4" md="4" cols="6" v-show="externalAccountHelperData.showDropbox">
            <v-card @click="externalAccountHelperData.doCreateDropbox()" style="cursor: pointer; max-width: 13rem;">
              <v-card-item>
                <h1 class="text-center">
                  <v-icon icon="mdi-dropbox"/>
                </h1>
                <h4 class="text-center">Dropbox Account</h4>
              </v-card-item>
            </v-card>
          </v-col>
          <v-col lg="4" md="4" cols="6" v-show="externalAccountHelperData.showAllOptions">
            <v-card  @click="externalAccountHelperData.createFTP()" style="cursor: pointer; max-width: 13rem;">
              <v-card-item>
                <h1 class="text-center">
                  <v-icon icon="mdi-server"/>
                </h1>
                <h4 class="text-center">FTP Account</h4>
              </v-card-item>
            </v-card>
          </v-col>
          <v-col lg="4" md="4" cols="6" v-show="externalAccountHelperData.showSftp">
            <v-card  @click="externalAccountHelperData.createSFTP()" style="cursor: pointer; max-width: 13rem;">
              <v-card-item>
                <h1 class="text-center">
                  <v-icon icon="mdi-server"/>
                </h1>
                <h4 class="text-center">SFTP Account</h4>
              </v-card-item>
            </v-card>
          </v-col>
          <v-col lg="4" md="4" cols="6" v-show="externalAccountHelperData.showAllOptions">
            <v-card  @click="externalAccountHelperData.createS3()" style="cursor: pointer; max-width: 13rem;">
              <v-card-item>
                <h1 class="text-center">
                  <v-icon icon="mdi-aws"/>
                </h1>
                <h4 class="text-center">S3 Account</h4>
              </v-card-item>
            </v-card>
          </v-col>
          <v-col lg="4" md="4" cols="6"  v-show="externalAccountHelperData.showGoogle">
            <v-card @click="externalAccountHelperData.doCreateGoogleDrive()" style="cursor: pointer; max-width: 13rem;">
              <v-card-item>
                <h1 class="text-center">
                  <v-icon icon="mdi-google"/>
                </h1>
                <h4 class="text-center">Google Drive</h4>
              </v-card-item>
            </v-card>
          </v-col>
          <v-col lg="4" md="4" cols="6"  v-show="externalAccountHelperData.showBox">
            <v-card @click="externalAccountHelperData.doCreateBox()" style="cursor: pointer; max-width: 13rem;">
              <v-card-item>
                <h1 class="text-center">
                  <v-icon icon="mdi-box"/>
                </h1>
                <h4 class="text-center">Box Account</h4>
              </v-card-item>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider class="my-2" />
      <v-card-actions>
        <v-spacer />
        <v-btn variant="flat" color="black" class="text-none mr-3" @click="externalAccountHelperData.modalVisible = false">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!--External account-->
  <v-dialog v-model="taskHelperData.modalVisible" width="500" class="pt-3">
    <div class="bg-white px-8 py-5 rounded-lg elevation-3 overflow-auto">
      <div class="text-h5 pb-2">
        <v-icon @click="taskHelperData.modalVisible=false" style="float: right" size="x-small" icon="mdi-window-close"></v-icon>
      </div>
      <div class="text-h4 pa-3">
        <p v-if="taskHelperData.modalTask == null && taskHelperData.modalPlaceholder != ''" class="text-center">{{ taskHelperData.modalPlaceholder }}</p>
        <div class="text-center" style="word-wrap: break-word;" v-if="taskHelperData && taskHelperData.modalTask != null">
          <v-row no-gutters>
            <v-col lg="12" md="12" sm="12" xs="12">
              <p style="font-size:1.3rem">{{ taskHelperData.modalTask['taskStatus']['response'] }}</p>
              <v-progress-linear color="black" indeterminate rounded height="6" v-if="taskHelperData.modalTask['taskStatus']['status'] == 0"></v-progress-linear>
            </v-col>
            <v-col lg="12" md="12" sm="12" xs="12" v-if="taskHelperData.modalTask['taskStatus']['status'] == 2">
              <div class="progress">
                <v-row class="fill-height" align-content="center" justify="center">
                  <v-col class="text-subtitle-1 text-center" cols="12">
                  </v-col>
                  <v-col cols="6">
                    <v-progress-linear color="black" indeterminate rounded height="6"></v-progress-linear>
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col lg="12" md="12" sm="12" xs="12" v-if="taskHelperData.modalTask['taskStatus']['status'] == 1 && taskHelperData.modalTask['taskStatus']['url'] !== undefined">
              <div>
                <v-btn prepend-icon="mdi-download" @click="taskHelperData.downloadFile(taskHelperData.modalTask['historyId'], taskHelperData.modalTask['type'])" variant="flat" color="black" class="text-none" >
                  <template v-slot:prepend>
                    <v-icon icon="mdi-download"></v-icon>
                  </template>
                  Download
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-divider class="mt-3"/>
          <v-row no-gutters>
            <v-col :cols="3">
              <v-card-actions v-if="taskHelperData.modalTask && taskHelperData.modalTask['taskInfo'] && taskHelperData.modalTask['taskInfo'] !== undefined && Object.keys(taskHelperData.modalTask['taskInfo']).length > 0 && taskHelperData.modalTask['taskInfo'] !== ''">
                <v-tooltip :target="taskHelperData.modalTask && '#popover-task-info-' + taskHelperData.modalTask['historyId']" location="top" :open-on-focus="true" :open-on-hover="true" >
                  <template v-slot:activator="{props}">
                    <div>
                      <v-btn :id="'popover-task-info' + (taskHelperData.modalTask ? taskHelperData.modalTask['historyId']: '')" variant="flat" color="black" size="small" v-bind="props" class="text-none">More Info</v-btn>
                    </div>
                  </template>
                  <div>
                    <p v-if="taskHelperData && taskHelperData.modalTask['taskInfo']">
                      <span v-for="(value, key) in taskHelperData.modalTask['taskInfo']">{{ key }}: {{ value }} <br> </span>
                    </p>
                  </div>
                </v-tooltip>
              </v-card-actions>
            </v-col>
            <v-col lg="9" md="9" :sm="taskHelperData && taskHelperData.modalTask && taskHelperData.modalTask['taskStatus']['status'] == 2 ? 12 : 9" :xs="taskHelperData && taskHelperData.modalTask && taskHelperData.modalTask['taskStatus']['status'] == 2 ? 12 : 9">
              <v-card-actions class="justify-end">
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex justify-end mb-3" v-if="taskHelperData && taskHelperData.modalTask && taskHelperData.modalTask['taskStatus']['status'] == 2">
                    <v-btn size="small" class="text-none" color="black" prepend-icon="mdi-timer" variant="flat" @click="taskHelperData.cancelTask(taskHelperData.modalTask['historyId']); taskHelperData.hideModal();">Cancel the execution</v-btn>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-end mb-3" v-if="taskHelperData && taskHelperData.modalTask && taskHelperData.modalTask['taskStatus'] && taskHelperData.modalTask['taskStatus']['status'] == 2">
                    <v-btn size="small" class="text-none" color="black" prepend-icon="mdi-inbox" variant="flat"  @click="taskHelperData.hideModal()">Run in the background</v-btn>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-end mt-2" v-if="taskHelperData && taskHelperData.modalTask && taskHelperData.modalTask['taskStatus'] && taskHelperData.modalTask['taskStatus']['status'] != 2" >
                    <v-btn size="small" class="text-none" color="black" variant="flat" @click="taskHelperData.hideModal();">Close</v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </v-dialog>

  <v-dialog v-model="createDatabaseHelperData.modalVisible" width="500">
    <div class="border rounded-lg bg-white overflow-hidden">
      <div class="pa-3 bg-grey-lighten-4 d-flex justify-space-between">
        <div class="text-h6">Create Database</div>
        <v-icon @click="createDatabaseHelperData.modalVisible = false" icon="mdi-close-circle cursor-pointer" class="d-block" />
      </div>

      <div class="pa-4">
        <div><label class="font-weight-bold">Enter a new database name:</label></div>
        <v-text-field density="compact" variant="outlined" id="databaseName-input" v-model="createDatabaseHelperData.newDbName" />
        <v-btn class="text-none float-end ma-3" color="black" :loading="createDatabaseHelperData.isCreatingDb" :disabled="createDatabaseHelperData.isCreatingDb" @click="createDatabaseHelperData.createDb()">Create</v-btn>
      </div>
    </div>
  </v-dialog>
</template>


<script lang="ts" setup>

import {onBeforeMount, ref, watch} from "vue";
import externalAccountHelper from '../service/ExternalAccountHelperService';
import taskHelper from '../service/TaskHelperService';
import createDatabaseHelper from "../service/createDatabaseHelper";
import {onBeforeRouteUpdate} from "vue-router";

const externalAccountHelperData = ref(externalAccountHelper);
const createDatabaseHelperData = ref(createDatabaseHelper);
const createQuestionModal = ref(false);
const sftpAuthType = ref([
  {id: 'password', name: 'Username & Password'},
  {id: 'key', name: 'RSA Key'}
]);
const s3AuthMethod = ref([
  {id: 'pool_id', name: 'Identity Pool ID'},
  {id: 'access_key', name: 'Access Key'}]);
const taskHelperData = ref(taskHelper);
const isActiveModal = ref<any>(false);
const regionList = ref<any>([...externalAccountHelperData.value.regionList])

onBeforeRouteUpdate(async (to,from,next) => {
  await taskHelperData.value.reload();
  externalAccountHelperData.value.region = null;
  next();
})

onBeforeMount(async () => {
  await load();
})

watch(() => taskHelperData.value.modalTask, () => {
  taskHelperData.value.modalVisible = taskHelperData.value.modalTask != null;
});

watch(() => taskHelperData.value.modalPlaceholder, (newVal,oldVal) => {
  if (newVal !== '') {
    taskHelperData.value.modalVisible = true;
  }
});

watch(() => taskHelperData.value.modalVisible, (newVal,oldVal) => {
  if (taskHelperData.value.modalVisible === false) {
    taskHelperData.value.modalTask = null;
    window.location.reload();
  }
  if (newVal === false && oldVal === true) {
    taskHelperData.value.modalPlaceholder = '';
    for (let f of taskHelperData.value.onModalClose) {
      // this.taskHelper.$timeout(f, 1000);
    }
    taskHelperData.value.onModalClose = [];
  }
});

function closeModal() {
  externalAccountHelperData.value.modalFTPVisible = false;
  externalAccountHelperData.value.modalSFTPVisible = false;
  externalAccountHelperData.value.modalS3Visible = false;
  externalAccountHelperData.value.modalVisible = false;
}
async function load() {
  if (window.location.pathname != '/crapp/scan/edit/') {
    await taskHelperData.value.init();
    await taskHelperData.value.reload();
  }
}


</script>
